import ApiService from '@/common/api.service'
export default {
    searchPortal () {
        return new Promise((resolve, reject) => {
            ApiService.query('/emergency-message/list').then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
